export default {
    mode: import.meta.env.MODE,
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    aiXplainApiKey: import.meta.env.VITE_AIXPLAIN_API_KEY,
    env: import.meta.env,
}
